module.exports = __webpack_public_path__ + "img/logo-light.3bfdc7dd.png";